export const isUserBrowser = () => {
  return navigator?.userAgent
    ? !/bot\b|APIs-Google|Lighthouse|curl|spider|crawl|wget|slurp|DuplexWeb|googleweblight|FeedfetchJson|Mediapartners-Google/i.test(
        navigator?.userAgent,
      )
    : true;
};
